import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "./api";

let cached = null;
let inflight = null;

/**
 * Returns the public app metadata (BETA flag, payments enabled, etc).
 * Cached in-memory after the first successful call.
 */
export default function useAppInfo() {
  const [info, setInfo] = useState(cached);

  useEffect(() => {
    if (cached) return;
    if (!inflight) {
      inflight = axios.get(`${BACKEND_URL}/api/app/info`)
        .then(({ data }) => { cached = data; return data; })
        .catch(() => { cached = { app_name: "Pronto", beta_mode: true, payments_enabled: false }; return cached; })
        .finally(() => { inflight = null; });
    }
    inflight.then((data) => setInfo(data));
  }, []);

  return info || cached || { beta_mode: true, payments_enabled: false };
}
